export default "/images/bea1171684014db7f9150d38b1fe40d2.avif";